// ** React Imports
import { Fragment } from 'react';

// ** Custom Components
import NavbarUser from './NavbarUser';
import Media from 'react-media';
import { isCandidate } from '@services/authentificationServices';
import { Link } from 'react-router-dom';

const ThemeNavbar = props => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props

  const appLogoImage = require('@src/assets/images/logo/logo VJ_#d91d0b_1 1.png').default;

  return (
    <Fragment>
      {/* {
        !isCandidate() && (
          <Media queries={{ small: '(max-width: 400px)' }}>
            {matches => (
              matches.small && (
                <div className='full-width mb-1'>
                  <div className='nav navbar-nav justify-content-center align-items-center ml-auto'>
                    <Link to={'/'} className='position-relative'>
                      <span className='brand-logo'>
                        <img src={appLogoImage} height={40} alt='logo' className='brand-logo' />
                      </span>
                    </Link>
                  </div>
                </div>
              )
            )}
          </Media>
        )
      } */}
      {/* <div className='d-flex'> */}
        <NavbarUser skin={skin} setSkin={setSkin} setMenuVisibility={setMenuVisibility} />
      {/* </div> */}
    </Fragment>
  )
}

export default ThemeNavbar
